/*
Sohel 11/22/2022 2701012930 formula Rule Group Table changes
*/
import React, {useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import FormulaRuleGroup from './../../../BRE/FormulaRuleGroup/SearchRuleGroup/index';
function SearchReportMaster({setValue, handleClose, returnTypeData, setBreCode}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <div className={classes.dialoguecardStyles}>
      <FormulaRuleGroup
        // setValue={setValue}
        // handleClose={handleClose}
        // setBreCode={setBreCode}
        // returnTypeData={returnTypeData}
        addAccount={true}
        addAction={true}
      />
    </div>
  );
}

export default SearchReportMaster;
